import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TaskSubType } from 'app/shared/enums/task-messages.enum';

export type MessageType = 'system' | 'self' | 'other';

@Component({
    selector: 'app-message-bubble',
    templateUrl: './message-bubble.component.html',
    imports: [CommonModule, TranslateModule]
})
export class MessageBubbleComponent {
  @Input() public type: MessageType = 'other';
  @Input() public content = '';
  @Input() public sender = '';
  @Input() public timestamp = '';
  @Input() public variant: 'default' | 'highlighted' = 'default';
  @Input() public subtype!: string;

  public readonly taskSubType = TaskSubType;

  public get containerClasses(): string {
    const baseClasses = 'w-[90%] flex';
    return this.type === 'self'
      ? `${baseClasses} ml-auto flex-col items-end`
      : `${baseClasses} mr-auto flex-col-reverse items-start`;
  }

  public get messageClasses(): string {
    const baseClasses = 'p-4 break-all';
    switch (this.type) {
      case 'system':
        return `${baseClasses} bg-[var(--secondary-60)] text-[var(--secondary-10)] rounded-r-lg rounded-bl-lg`; // No top-left radius
      case 'self':
        return `${baseClasses} bg-[var(--primary-90)] text-[var(--primary-10)] rounded-l-lg rounded-tr-lg`; // No bottom-right radius
      case 'other': {
        const highlightClasses =
          this.variant === 'highlighted'
            ? 'bg-[var(--primary-40)] text-[var(--primary-100)]'
            : 'bg-[var(--neutral-90)] text-[var(--neutral-10)]';
        return `${baseClasses} ${highlightClasses} rounded-r-lg rounded-bl-lg`;
      }
      default:
        return baseClasses;
    }
  }
}
